import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';
import { useCart } from './CartContext';

function Cart() {
  const { cart, removeFromCart, updateQuantity, getCartTotal, clearCart } = useCart();
  const navigate = useNavigate();

  const handleCheckout = () => {
    if (cart.length > 0) {
      navigate('/books/checkout');
    }
  };

  const handleRemove = (bookKey) => {
    removeFromCart(bookKey);
  };

  const handleQuantityChange = (bookKey, newQuantity) => {
    updateQuantity(bookKey, parseInt(newQuantity) || 1);
  };

  const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 480px)').matches;

  return (
    <div className="main-bg">
      {!isMobile && (
        <header className="hero-section">
          <h1 className="site-title">Shopping Cart</h1>
          <p className="site-tagline">Review your items before checkout.</p>
        </header>
      )}
      <div className="cart-section">
        {cart.length === 0 ? (
          <div className="cart-empty">
            <h2>Your cart is empty</h2>
            <p>Add some books to your cart to get started!</p>
            <button className="book-btn" onClick={() => navigate('/books')}>
              Browse Books
            </button>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {cart.map((item) => (
                <div key={item.key} className="cart-item">
                  <img src={item.img} alt={item.title} className="cart-item-img" />
                  <div className="cart-item-details">
                    <h3>{item.title}</h3>
                    <p className="book-type">Physical Copy of book</p>
                    <p className="cart-item-price">${item.price} each</p>
                    <div className="cart-item-controls">
                      <label>
                        Quantity:
                        <input
                          type="number"
                          min="1"
                          value={item.quantity}
                          onChange={(e) => handleQuantityChange(item.key, e.target.value)}
                          className="quantity-input"
                        />
                      </label>
                      <button
                        className="remove-btn"
                        onClick={() => handleRemove(item.key)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                  <div className="cart-item-total">
                    ${(item.price * item.quantity).toFixed(2)}
                  </div>
                </div>
              ))}
            </div>
            <div className="cart-summary">
              <div className="cart-total">
                <h3>Total: ${getCartTotal().toFixed(2)}</h3>
              </div>
              <div className="cart-actions">
                <button className="clear-cart-btn" onClick={clearCart}>
                  Clear Cart
                </button>
                <button className="checkout-btn" onClick={handleCheckout}>
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </>
        )}
      </div>
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Life Force Dynamics. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Cart;


